import { Loc } from 'main.core';
import { UserSpecificNoticeBase } from 'b24network.vue.invite-shared';
import { UserAccount } from 'b24network.vue.cross-scenario-shared-js';

/**
 * User has invitation but haven't accepted it to join to a portal
 */
export class UserNotJoinedToPortal extends UserSpecificNoticeBase
{
	#notYetAcceptedInvites: [];

	constructor(portalName: string, account: UserAccount, notYetAcceptedInvites: [])
	{
		const noticeText = null;

		super(
			noticeText,
			account,
			Loc.getMessage('EXT_B24NET_LOGGING_IN_YOU_NOT_ACCEPTED_INVITE', {
				'[b]': '<b>',
				'[/b]': '</b>',
				'[br]': '<br>',
				'#PORTAL_NAME#': portalName,
			}),
		);

		this.#notYetAcceptedInvites = notYetAcceptedInvites;
	}

	toNotYetAcceptedInvites(): []
	{
		return this.#notYetAcceptedInvites;
	}
}
